import Autocomplete from '../components/autocomplete';
import { getWebsiteIdFromPath } from '../util/websiteIdExtractor';

class CustomerSearch {
    bind() {
        for (const customerSearch of document.querySelectorAll('[data-crm-customer-search-form]')) {
            if (customerSearch === null || customerSearch.dataset.bound) {
                return;
            }

            const searchField = customerSearch.querySelector('[data-crm-customer-search-field]');
            const idField = customerSearch.querySelector('[data-crm-customer-id]');
            const autocomplete = new Autocomplete();
            const autoCompleteSuggestionArea = autocomplete.createContainer();
            customerSearch.appendChild(autoCompleteSuggestionArea);

            function createSuggestion(data) {
                const suggestion = autocomplete.createElement();

                suggestion.innerHTML = `<div class="flex flex-col">
    <div>${data.firstName} ${data.lastName}</div>`;

                if (data.company !== null) {
                    suggestion.innerHTML += `<div class="text-xs font-bold">${data.company.companyName}</div>`;
                }

                suggestion.innerHTML += '</div>';

                suggestion.addEventListener('click', () => {
                    idField.value = data.id;
                    searchField.value = data.displayName;
                    autoCompleteSuggestionArea.hidden = true;
                });

                return suggestion;
            }

            function updateSuggestions() {
                fetch(`/${getWebsiteIdFromPath()}/crm/customer/search?q=${searchField.value}`)
                    .then((response) => response.json())
                    .then((json) => {
                        autoCompleteSuggestionArea.innerText = '';
                        if (json.error !== undefined) {
                            return;
                        }

                        for (const suggestion of json) {
                            autoCompleteSuggestionArea.appendChild(createSuggestion(suggestion));
                            autoCompleteSuggestionArea.hidden = false;
                        }
                    });
            }

            function bindField(field) {
                field.addEventListener('input', () => {
                    if (field.value.length < 2) {
                        autoCompleteSuggestionArea.hidden = true;
                        return;
                    }

                    updateSuggestions();
                });
            }

            bindField(searchField);

            customerSearch.dataset.bound = 'true';
        }
    }
}

const customerSearch = new CustomerSearch();
customerSearch.bind();

document.addEventListener('click', () => {
    customerSearch.bind();
});
